import { getHikedPrice, getTaxAmount, getTransationCharges } from './getAmountWithTransaction';
import { getTotalSeatCount } from './getTotalSeatCount';

export function calculatePayment({ bookingData, paymentType, offerAmo = 0, cashToRedeem = 0 }) {
    let actual = 0;
    let tax = 0;
    let baseTotal = 0;
    let reservePrice = 0;
    let remainingAmount = 0;
    //calaculation for custom trip
    if (bookingData.datesType === 'custom') {
        actual = bookingData?.amountPaid?.actual || 0;
        tax = bookingData?.amountPaid?.tax || 0;
        baseTotal = bookingData?.amountPaid?.total || actual + tax;
        reservePrice = bookingData?.amountPaid.reserve;

        remainingAmount = bookingData?.amountPaid?.isReserved ? baseTotal - bookingData?.amountPaid?.reserve : 0;
    }
    //calculation for fixed trip
    else {
        const { actualPrice, people, roomAmount = 0, vehiclePrice = 0, totalAmo, isReserved } = bookingData;

        actual = actualPrice * people + roomAmount + vehiclePrice;
        tax = getTaxAmount(actualPrice * people);
        baseTotal = actual + tax;
        reservePrice = totalAmo;

        remainingAmount = isReserved ? baseTotal - totalAmo : 0;
    }

    const offerAmount = cashToRedeem > 0 ? Number(cashToRedeem) : Number(offerAmo || 0);

    const afterOffer = baseTotal - offerAmount;

    const convenienceFee = getTransationCharges(afterOffer);

    const reserveConvenienceFee = getTransationCharges(reservePrice);

    const finalPayable = paymentType === 'UPI' ? Math.round(afterOffer) : Math.round(afterOffer + convenienceFee);

    reservePrice = paymentType === 'UPI' ? Math.round(reservePrice) : Math.round(reservePrice + reserveConvenienceFee);

    return {
        actual,
        tax,
        baseTotal,
        offerAmount,
        convenienceFee: Math.round(convenienceFee),
        reserveConvenienceFee: Math.round(reserveConvenienceFee),
        finalPayable,
        reservePrice,
        remainingAmount
    };
}

export function calculatePaymentAll({ bookingData, paymentType }) {
    let sub_total = 0;
    let tax = 0;
    let convenienceFee = 0;
    let total = 0;
    let remainingAmount = 0;
    let roomPrice = 0;
    let offerAmount = bookingData?.amountPaid?.offerAmount || 0;
    let discount = 0;
    let vehiclePrice = bookingData.vehiclePrice || 0;

    if (bookingData?.type === 'trip') {
        if (bookingData?.amountPaid?.isReserved) {
            sub_total = bookingData?.amountPaid?.reserve * bookingData.totalSeats;
            tax = bookingData?.amountPaid?.tax;
            convenienceFee = getTransationCharges(sub_total);
            total = paymentType === 'UPI' ? sub_total : sub_total + convenienceFee;
            remainingAmount = bookingData?.amountPaid?.total - sub_total;
        } else {
            tax = bookingData?.amountPaid.tax;
            roomPrice = bookingData.totalRooms > 0 ? bookingData.totalRooms * bookingData.roomPrice : 0;
            sub_total = getHikedPrice(bookingData?.amountPaid?.actual - roomPrice - vehiclePrice);
            discount = sub_total - (bookingData?.amountPaid?.actual - roomPrice - vehiclePrice);
            convenienceFee = getTransationCharges(bookingData?.amountPaid?.total - offerAmount);
            total = bookingData?.amountPaid?.paid;
        }
    }

    if (bookingData?.type === 'act') {
        if (bookingData?.amountPaid?.isReserved) {
            const reserveDetails = bookingData?.amountPaid?.reserve || [];
            const totalSeats = bookingData?.totalSeats || [];

            // Calculate reservation amount
            sub_total = reserveDetails.reduce((total, reserveItem) => {
                const matchingSeat = totalSeats.find((seat) => seat.name === reserveItem.name);

                const qty = Number(matchingSeat?.qty || 1);
                const amount = Number(reserveItem?.amount || 0);

                return total + amount * qty;
            }, 0);

            tax = Number(bookingData?.amountPaid?.tax || 0);

            convenienceFee = Number(getTransationCharges(sub_total) || 0);

            total = paymentType === 'UPI' ? sub_total : sub_total + convenienceFee;

            remainingAmount = Number(bookingData?.amountPaid?.total || 0) - sub_total;
        } else {
            tax = Number(bookingData?.amountPaid?.tax || 0);

            sub_total = Number(getHikedPrice(bookingData?.amountPaid?.actual) || 0);

            discount = sub_total - Number(bookingData?.amountPaid?.actual || 0);

            convenienceFee = Number(
                getTransationCharges(Number(bookingData?.amountPaid?.total || 0) - Number(offerAmount || 0)) || 0
            );

            total = Number(bookingData?.amountPaid?.paid || 0);
        }
    }

    if (bookingData?.type === 'gu') {
        if (bookingData?.amountPaid?.isReserved) {
            sub_total = bookingData?.amountPaid?.reserve * bookingData.totalSeats;
            tax = bookingData?.amountPaid?.tax;
            convenienceFee = getTransationCharges(sub_total);
            total = paymentType === 'UPI' ? sub_total : sub_total + convenienceFee;
            remainingAmount = bookingData?.amountPaid?.total - sub_total;
        } else {
            tax = bookingData?.amountPaid.tax;
            sub_total = getHikedPrice(bookingData?.amountPaid?.actual);
            discount = sub_total - bookingData?.amountPaid?.actual;
            convenienceFee = getTransationCharges(bookingData?.amountPaid?.total - offerAmount);
            total = bookingData?.amountPaid?.paid;
        }
    }

    return {
        sub_total,
        tax,
        offerAmount,
        convenienceFee,
        total,
        roomPrice,
        remainingAmount,
        discount,
        vehiclePrice
    };
}
